import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  username: "",
  email: "",
  hash: "",
  agreeMarketingComms: false,
  agreeReminders: false,
  currentLanguage: "fr",
  lingoleafStaff: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginUser: (state, action) => {
      const {
        username, email, hash,
        agreeMarketingComms, agreeReminders,
        currentLanguage, lingoleafStaff,
      } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        username,
        email,
        hash,
        agreeMarketingComms,
        agreeReminders,
        currentLanguage,
        lingoleafStaff,
      };
    },
    logoutUser: () => initialState,
    setCurrentLanguage: (state, action) => { 
      state.currentLanguage = action.payload;
    },
    setAgreeMarketingComms: (state, action) => {
      state.agreeMarketingComms = action.payload;
    },
    setAgreeReminders: (state, action) => {
      state.agreeReminders = action.payload;
    },
  },
});

// exports. NB: when adding a new action to streak reducer, also add it to syncableUserActions if it should sync with user DB
export const { loginUser, logoutUser, setCurrentLanguage, setAgreeMarketingComms, setAgreeReminders } = userSlice.actions;
export const syncableUserActions = [
  setCurrentLanguage,
  setAgreeMarketingComms,
  setAgreeReminders,
];
export default userSlice.reducer;
